import React, { type FC, useEffect } from 'react';
import type { FormApi } from 'final-form';

import { useFormStateSafe } from '../../context';

import type { IProps } from './models';

// TODO: выпилить при атомизации компонентов
export const NativeForm: FC<IProps> = ({
    children,
    dataTestId = 'sme-native-form',
    decorator,
    innerRef,
    isBusinessLoggingEnabled,
    ...rest
}) => {
    const formApi = useFormStateSafe({
        subscription: {
            values: true,
        },
    });

    useEffect(() => {
        if (isBusinessLoggingEnabled && formApi) {
            decorator(formApi as unknown as FormApi<Record<string, unknown>>);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formApi?.values]);

    return (
        <form ref={innerRef} data-test-id={dataTestId} {...rest}>
            {children}
        </form>
    );
};
